<template>
  <div class="step">
    <riseup-header/>
    <div class="content">

      <div class="enter-details">
        <div class="intro">הרשמה</div>
        <div class="title">איך קוראים לך?</div>

        <div class="inputs">
          <text-input
            :autofocus="true"
            :labelText="'שם פרטי'"
            :value="firstName"
            :onInput="checkAndSetFirstName"
            :error="false"
            :topLeftLabel="''"/>

          <text-input
            :autofocus="false"
            :labelText="'שם משפחה'"
            :value="lastName"
            :onInput="checkAndSetLastName"
            :error="false"
            :topLeftLabel="''"/>
        </div>
      </div>

      <div>
        <sun/>

        <div class="enter-details">
          <riseup-button class="cta" :disabled="disabled" title="קדימה" :size="'small'" :action="nextClicked"/>

          <div class="action" v-on:click="goToLogin">
            כבר הצטרפת לשירות?
            <div class="action-link"> הכניסה מכאן</div>
          </div>
        </div>
        <information-details title="חודש התנסות חינם לנרשמים עכשיו!"
                             :details="['35 ימי ניסיון בחינם ובלי התחייבות',
                      'בסוף תקופת הניסיון אפשר לבחור אם להמשיך למנוי בתשלום של ₪45 לחודש',
                      'לא צריך להוסיף אמצעי תשלום עד סוף תקופת הניסיון']"/>
      </div>
    </div>
  </div>
</template>

<script>

import RiseupHeader from '@/base-components/app-header/RiseupHeader.vue';
import Segment from '@/Segment';
import BrowserInfo from '@/mixins/BrowserInfo';
import BaseUI from 'base-ui';
import _ from 'lodash';
import { mapMutations, mapState } from 'vuex';
import router from '@/router';
import Sun from './Sun';
import InformationDetails from '../../signup/steps/InformationDetails';

export default {
  name: 'EnterName',
  mixins: [BrowserInfo],
  components: {
    RiseupHeader,
    TextInput: BaseUI.TextInput,
    RiseupButton: BaseUI.RiseupButton,
    Sun,
    InformationDetails,
  },
  props: {
    nextStep: {
      type: Function,
      required: true,
    },
  },
  created() {
    Segment.trackUserGot('SignUp_V1_EnterName_Entered_Marketing');
    Segment.trackUserGot('RegistrationEntered_Split', { userAgentFromNavigator: this.userAgent, isFacebookApp: this.isFacebookApp });
    Segment.trackUserGotToPixel('RE_Split');
    Segment.trackUserGotToPixel('RegistrationEntered_Split_NameEntered');
  },
  computed: {
    ...mapState('signup', ['firstName', 'lastName']),
    disabled() {
      return _.trim(this.firstName).length < 2 || _.trim(this.lastName).length < 2;
    },
  },
  methods: {
    ...mapMutations('signup', ['setFirstName', 'setLastName']),
    checkAndSetFirstName(value) {
      this.setFirstName(value);
    },
    checkAndSetLastName(value) {
      this.setLastName(value);
    },
    goToLogin() {
      Segment.trackUserInteraction('GoToLogin_Split');
      router.push({ path: '/sr', query: { ...this.$route.query, returning: true } });
    },
    nextClicked() {
      Segment.trackUserInteraction('SignUp_V1_EnterName_NextClicked_Marketing');
      Segment.trackUserGotToPixel('RegistrationEntered_Split_NameEntered_NextClicked');
      this.nextStep();
    },
  },
};

</script>
<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '@/scss/mixins';

.step {
  @include white-page-frame;
  height: 100%;

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .enter-details {

    @include responsive-padding;
    color: $riseup_black;
    width: 100%;

    .intro {
      margin-top: 32px;
      font-size: 18px;
      line-height: 28px;
    }

    .inputs {
      margin-top: 25px;
    }

    .title {
      font-family: SimplerPro;
      font-weight: bold;
      font-size: 22px;
      line-height: 28px;
      display: inline-block;
      width: 100%;
    }

    .action {
      display: flex;
      justify-content: center;
      margin: 40px 0px;
      color: $riseup_black;
      font-size: 18px;
      line-height: 10px;

      .action-link {
        font-weight: bold;
        color: $riseup_blue;
        cursor: pointer;
        text-decoration: underline;
        margin-right: 5px;
      }
    }

    .cta {
      margin-top: 30px;
      width: 100%;
    }
  }
}
</style>
